export function isIE() {
  const ua = window.navigator.userAgent;
  return /MSIE|Trident/.test(ua);
}

export function isOpera() {
  return (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
}

export const isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
